const church = [
  {
    id: 1,
    image: "https://i.ibb.co/TBX052bw/photo-2026-02-23-14-51-18.jpg",
    code: "Укр. 1",
    price: "",
  },
  {
    id: 2,
    image: "https://i.ibb.co/20TZXyrY/photo-2026-02-23-14-51-22.jpg",
    code: "Укр. 2",
    price: "",
  },
  {
    id: 3,
    image: "https://i.ibb.co/YF5FkJgd/photo-2026-02-23-14-51-24.jpg",
    code: "Укр. 3",
    price: "",
  },
  {
    id: 4,
    image: "https://i.ibb.co/vC5HdPQy/photo-2026-02-23-16-15-13.jpg",
    code: "Укр. 4",
    price: "",
  },
];

export default church;
